/**
 * Twin over MCP (v0.1.215; Sercan, 20 Oct 2026: "tüm bilgilere mcp ile ulaşabilecek alt yapı", "şifresiz olsun"): the
 * Claude app and ChatGPT read Twin at /api/v1/mcp/<token>, read only, personal details masked. The token in the address
 * is the only credential; Sercan makes and revokes addresses on Ayarlar:
 *   GET  /api/v1/settings/mcp               panel: the addresses (never the token)
 *   POST /api/v1/settings/mcp               panel: { label } makes one; the address is shown once
 *   POST /api/v1/settings/mcp/{id}/revoke   panel: the address stops working at once
 */
import { z } from 'zod';
import { isoDateTimeSchema } from '../ids.js';
/** At most this many live addresses (one per app is the plan). */
export const MCP_ADDRESSES_MAX = 5;
/** The token in the address: 32 random bytes, base64url. */
export const MCP_TOKEN_PATTERN = /^[A-Za-z0-9_-]{43}$/;
export const mcpAddressSchema = z.strictObject({
    id: z.string().max(20),
    label: z.string().max(60),
    createdAt: isoDateTimeSchema,
    lastUsedAt: isoDateTimeSchema.nullable(),
    revokedAt: isoDateTimeSchema.nullable(),
});
export const mcpAddressListSchema = z.strictObject({ addresses: z.array(mcpAddressSchema) });
export const mcpAddressCreateSchema = z.strictObject({ label: z.string().trim().min(1).max(60) });
/** The new address, once: the panel shows it to copy and never gets it again. */
export const mcpAddressCreatedSchema = z.strictObject({ address: mcpAddressSchema, url: z.string().url().max(300) });
export const mcpAddressRevokedSchema = z.strictObject({ address: mcpAddressSchema });
//# sourceMappingURL=mcp.js.map